import { Col } from 'reactstrap';
import styled from 'styled-components';

export const CardSelect = styled(Col)`
  position:absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
`;